import React, { Component } from 'react';

import * as am4core from '@amcharts/amcharts4/core';
import * as am4charts from '@amcharts/amcharts4/charts';

import { MEDIA_COLOR_SET } from '../../../../config/ColorSet';
// import SpinnerBox from '../../spinner-box/SpinnerBox';

class Line extends Component {
  constructor(props){
    super(props);
    // this.state = {
    //   chart: 'hidden',
    //   spinner: true
    // }
  }

  componentDidMount(){
    const data = this.props.data
    
    const selectEnable = true;
    let chart = null;
    this.createLine(chart, data, selectEnable);
  }

  componentWillUnmount(){
    if(this.chart) {
      this.chart.dispose()
    };
  }

  componentDidUpdate(prevProps){
    if((this.props.data != null) && (prevProps.data !== this.props.data)){
      if(this.chart){
        this.chart.dispose();
      }
      const selectEnable = true;
      let chart = null;
      this.createLine(chart, this.props.data, selectEnable);
    }
  }
  
  createLine = (chart, dataSet, selectEnable) => {
    chart = am4core.create(this.lineChart, am4charts.XYChart);
    // chart.events.on('ready', ()=>{this.setState({chart:'visible', spinner:false})});
    chart.data = dataSet;

    let dateAxis = chart.xAxes.push(new am4charts.DateAxis());
    let valueAxis = chart.yAxes.push(new am4charts.ValueAxis());

    dateAxis.renderer.minGridDistance = 20; 
    // dateAxis.renderer.grid.template.location = 0.5;
    // dateAxis.startLocation = 0.5;
    // dateAxis.endLocation = 0.5;
    dateAxis.renderer.labels.template.rotation = 90;  
    dateAxis.renderer.labels.template.horizontalCenter = "left";
    dateAxis.renderer.labels.template.verticalCenter = "middle";
    dateAxis.dateFormats.setKey("day", "yyyy-MM-dd");
    dateAxis.periodChangeDateFormats.setKey("day", "yyyy-MM-dd");
    // dateAxis.gridIntervals.setAll([{timeUnit: "day", count: 1}]);

    dateAxis.baseInterval = {timeUnit: "day", count: 1};


    valueAxis.renderer.grid.template.disabled = true;
    valueAxis.renderer.baseGrid.disabled = true;
    dateAxis.renderer.grid.template.disabled = true;

    let sumSeries = chart.series.push(new am4charts.LineSeries());
    sumSeries.dataFields.valueY = "sum-value";
    sumSeries.dataFields.dateX = "date";
    sumSeries.name = "Sum";
    sumSeries.strokeWidth = 3;
    sumSeries.stroke = am4core.color(MEDIA_COLOR_SET.sum);
    sumSeries.minBulletDistance = 1000;

    let sumBullet = sumSeries.bullets.push(new am4charts.CircleBullet());
    sumBullet.circle.fill = am4core.color(MEDIA_COLOR_SET.sum);

    sumSeries.tooltipText = "Sum ({dateX}): [bold]{valueY}[/]"
    sumSeries.tooltip.getFillFromObject = false;
    sumSeries.tooltip.background.fill = am4core.color(MEDIA_COLOR_SET.sum);
    sumSeries.tooltip.label.fill = am4core.color("#fff");
    

    if(selectEnable) {
      if (dataSet[0].hasOwnProperty('community-value')){
        let commuSeries = chart.series.push(new am4charts.LineSeries());
        commuSeries.dataFields.valueY = "community-value";
        commuSeries.dataFields.dateX = "date";
        commuSeries.name = "Community";
        commuSeries.strokeWidth = 3;
        commuSeries.stroke = am4core.color(MEDIA_COLOR_SET.community);
        commuSeries.minBulletDistance = 1000;
        
        let commuBullet = commuSeries.bullets.push(new am4charts.CircleBullet());
        commuBullet.circle.fill = am4core.color(MEDIA_COLOR_SET.community);
        commuSeries.tooltipText = "Community ({dateX}): [bold]{valueY}[/]"
        commuSeries.tooltip.getFillFromObject = false;      
        commuSeries.tooltip.background.fill = am4core.color(MEDIA_COLOR_SET.community);
        commuSeries.tooltip.label.fill = am4core.color("#fff");

      }

      
      if (dataSet[0].hasOwnProperty('news-value')){
        let newsSeries = chart.series.push(new am4charts.LineSeries());
        newsSeries.dataFields.valueY = "news-value";
        newsSeries.dataFields.dateX = "date";
        newsSeries.name = "News";
        newsSeries.strokeWidth = 3;
        newsSeries.stroke = am4core.color(MEDIA_COLOR_SET.news);
        newsSeries.minBulletDistance = 1000;
  
        let newsBullet = newsSeries.bullets.push(new am4charts.CircleBullet());
        newsBullet.circle.fill = am4core.color(MEDIA_COLOR_SET.news);
        newsSeries.tooltipText = "News ({dateX}): [bold]{valueY}[/]"
        newsSeries.tooltip.getFillFromObject = false;
        newsSeries.tooltip.background.fill = am4core.color(MEDIA_COLOR_SET.news);
        newsSeries.tooltip.label.fill = am4core.color("#fff");
      }

      if (dataSet[0].hasOwnProperty('club-value')){
        let clubSeries = chart.series.push(new am4charts.LineSeries());
        clubSeries.dataFields.valueY = "club-value";
        clubSeries.dataFields.dateX = "date";
        clubSeries.name = "Club";
        clubSeries.strokeWidth = 3;
        clubSeries.stroke = am4core.color(MEDIA_COLOR_SET.club);
        clubSeries.minBulletDistance = 1000;
  
        let clubBullet = clubSeries.bullets.push(new am4charts.CircleBullet());
        clubBullet.circle.fill = am4core.color(MEDIA_COLOR_SET.club);
        clubSeries.tooltipText = "Club ({dateX}): [bold]{valueY}[/]"
        clubSeries.tooltip.getFillFromObject = false;
        clubSeries.tooltip.background.fill = am4core.color(MEDIA_COLOR_SET.club);
        clubSeries.tooltip.label.fill = am4core.color("#fff");
      }

      if (dataSet[0].hasOwnProperty('twit-value')){
        let twitSeries = chart.series.push(new am4charts.LineSeries());
        twitSeries.dataFields.valueY = "twit-value";
        twitSeries.dataFields.dateX = "date";
        twitSeries.name = "Twit";
        twitSeries.strokeWidth = 3;   
        twitSeries.stroke = am4core.color(MEDIA_COLOR_SET.twitter);
        twitSeries.minBulletDistance = 1000;
  
        let twitBullet = twitSeries.bullets.push(new am4charts.CircleBullet());
        twitBullet.circle.fill = am4core.color(MEDIA_COLOR_SET.twitter);
        twitSeries.tooltipText = "Twitter ({dateX}): [bold]{valueY}[/]"
        twitSeries.tooltip.getFillFromObject = false;
        twitSeries.tooltip.background.fill = am4core.color(MEDIA_COLOR_SET.twitter);
        twitSeries.tooltip.label.fill = am4core.color("#fff");
      }

      if (dataSet[0].hasOwnProperty('blog-value')){
        let twitSeries = chart.series.push(new am4charts.LineSeries());
        twitSeries.dataFields.valueY = "blog-value";
        twitSeries.dataFields.dateX = "date";
        twitSeries.name = "Blog";
        twitSeries.strokeWidth = 3;   
        twitSeries.stroke = am4core.color(MEDIA_COLOR_SET.blog);
        twitSeries.minBulletDistance = 1000;
  
        let twitBullet = twitSeries.bullets.push(new am4charts.CircleBullet());
        twitBullet.circle.fill = am4core.color(MEDIA_COLOR_SET.blog);
        twitSeries.tooltipText = "Blog ({dateX}): [bold]{valueY}[/]"
        twitSeries.tooltip.getFillFromObject = false;
        twitSeries.tooltip.background.fill = am4core.color(MEDIA_COLOR_SET.blog);
        twitSeries.tooltip.label.fill = am4core.color("#fff");
      }

      // let etcSeries = chart.series.push(new am4charts.LineSeries());
      // etcSeries.dataFields.valueY = "etc-value";
      // etcSeries.dataFields.dateX = "date";
      // etcSeries.name = "Etc";
      // etcSeries.strokeWidth = 3;   
      // etcSeries.stroke = am4core.color(MEDIA_COLOR_SET.etc);
      // etcSeries.minBulletDistance = 1000;

      // let etcBullet = etcSeries.bullets.push(new am4charts.CircleBullet());
      //etcBullet.circle.fill = am4core.color(MEDIA_COLOR_SET.etc);

      chart.legend = new am4charts.Legend();   
    }


    chart.cursor = new am4charts.XYCursor();

    dateAxis.cursorTooltipEnabled = false;
    valueAxis.cursorTooltipEnabled = false;
    chart.cursor.lineX.disabled = true;
    chart.cursor.lineY.disabled = true;

    chart.cursor.behavior = "none"
    
    this.chart = chart;

  }

  render(){
    return(
      // <div>
      //   {this.state.spinner ? <SpinnerBox /> : undefined}
      //   <div id="line" ref={ref=>(this.lineChart=ref)} style={{ width: this.props.width, height: this.props.height, visibility: this.state.chart }}></div>
      // </div>
      <div>
        <div id="line" ref={ref=>(this.lineChart=ref)} style={{ width: this.props.width, height: this.props.height}}></div>
      </div>
    )
  }
}

export default Line;